module.exports = __webpack_public_path__ + "img/116022.860d2c04.png";